import React from 'react'
import BlogForm from '../components/BlogForm'

const NewBlog = () => {
  return (
    <div>
      <BlogForm />
    </div>
  )
}

export default NewBlog